module.exports = __webpack_public_path__ + "static/media/stefania-popova.56246517.png";